import { Dispatch } from "redux"
import { IGetSbCampaignsBody } from "../../types/sbCampaignApi.types"
import { SponsoredBrandsAction, SponsoredBrandsActionType } from "../types/sponsoredBrands"
import sbCampaignApi from "../../api/sbCampaign.api"
import sbTargetApi from "../../api/sbTarget.api"
import { IGetSbTargetBody } from "../../types/sbTargetApi.types"
import { ISbTargetDataForTable } from "../../types/sbTarget.types"

const fetchSponsoredBrandsCampaigns = (data: IGetSbCampaignsBody) => {
  return async (dispatch: Dispatch<SponsoredBrandsAction>) => {
    try {
      dispatch({ type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS })
      const sponsoredProductData = await sbCampaignApi.getSbCampaigns(data)

      dispatch({
        type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS_SUCCESS,
        payload: sponsoredProductData.data,
      })
    } catch (e) {
      dispatch({
        type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS_ERROR,
        payload: "sponsored brands load error",
      })
    }
  }
}

const fetchSponsoredBrandsTargets = (data: IGetSbTargetBody) => {
  return async (dispatch: Dispatch<SponsoredBrandsAction>) => {
    try {
      dispatch({ type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS })
      const targetsData = await sbTargetApi.getTargetData(data)

      dispatch({
        type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS_SUCCESS,
        payload: targetsData.data,
      })
    } catch (e) {
      dispatch({
        type: SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS_ERROR,
        payload: "sponsored brands targets load error",
      })
    }
  }
}

const updateTargetsLocal = (targets: ISbTargetDataForTable[]) => {
  return async (dispatch: Dispatch<SponsoredBrandsAction>) => {
    dispatch({
      type: SponsoredBrandsActionType.UPDATE_SPONSORED_BRANDS_TARGETS_LOCAL,
      payload: targets,
    })
  }
}

const copyTargetsToTargetsForTable = (targets: ISbTargetDataForTable[]) => {
  return async (dispatch: Dispatch<SponsoredBrandsAction>) => {
    dispatch({
      type: SponsoredBrandsActionType.ADD_SPONSORED_BRANDS_TARGETS,
      payload: targets,
    })
  }
}

const resetSponsoredBrandsTargets = () => {
  return (dispatch: Dispatch<SponsoredBrandsAction>) => {
    dispatch({ type: SponsoredBrandsActionType.RESET_SPONSORED_BRANDS_TARGETS })
  }
}

export default {
  fetchSponsoredBrandsCampaigns,
  fetchSponsoredBrandsTargets,
  updateTargetsLocal,
  copyTargetsToTargetsForTable,
  resetSponsoredBrandsTargets,
}
